/**
 * Копирование текста. `navigator.clipboard` есть только в защищённом контексте,
 * а телефон часто открывает приложение по локальному `http://…` — там работает
 * только старый трюк со скрытым полем.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Браузер отказал (нет разрешения или небезопасный контекст) — пробуем запасной путь.
  }

  try {
    const field = document.createElement('textarea')
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.opacity = '0'
    document.body.appendChild(field)
    field.select()
    field.setSelectionRange(0, text.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(field)
    return ok
  } catch {
    return false
  }
}

/** Системное «Поделиться»; false — если браузер его не умеет или отменили. */
export async function shareText(text: string, url: string): Promise<boolean> {
  if (typeof navigator.share !== 'function') {
    return false
  }

  try {
    await navigator.share({ text, url })
    return true
  } catch {
    return false
  }
}
